import classNames from 'classnames'
import React from 'react'
import { isNullOrWhiteSpace } from '../../../utilities/string'
import { Grid } from '../../Grid'
import { PersonLinkProps } from '../../PersonLink'
import { TeamList } from '../../TeamList'

export interface FundsContactPersonsSectionProps {
  gaTrackingId?: string
  id?: string
  team: PersonLinkProps[]
  title?: string
}

export const FundsContactPersonsSection = ({
  gaTrackingId,
  id,
  team,
  title,
}: FundsContactPersonsSectionProps) => (
  <Grid
    additionalClassName={classNames(
      'gap-y-30 pt-30 pb-60 bg-shade-lightest-warm',
      'tb:pt-45 tb:pb-75'
    )}
    as="section"
    id={id}
  >
    <div className={classNames('col-span-full flex flex-col gap-45 sm:gap-75')}>
      {!isNullOrWhiteSpace(title) && (
        <h2 className="font-h2 text-h2 text-primary text-center">{title}</h2>
      )}

      <TeamList gaTrackingId={gaTrackingId} scrollInLg={false} team={team} />
    </div>
  </Grid>
)
